import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { SliceCallState } from "../../slices/sliceCallState";
import { RootState } from "../../redux/store";

export const PermissionsGate = ({ children }: { children: JSX.Element }) => {
  const { token, loading } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (!token && loading !== SliceCallState.pending) {
      navigate("/signin");
    }
  }, [loading, navigate, token]);

  return children;
};
